import { getAll, getById } from '../utilities/querySelector';

getAll( '[aria-controls]' ).forEach( trigger => {
    const controlled = getById( trigger.getAttribute( 'aria-controls' ) );
    trigger.addEventListener( 'click', () => {
        const state = trigger.getAttribute( 'aria-expanded' );
        trigger.setAttribute( 'aria-expanded', toggleStringBool( state ) );
        controlled.setAttribute( 'aria-hidden', state );

        if ( trigger.hasAttribute( 'data-slide-toggle' ) ) {
            jQuery( controlled ).slideToggle( slideOptions );
        }
} );
} );

function toggleStringBool( bool ) {
    return ( bool === "true" || bool === "True" || bool === "TRUE" ) ? false : true;
}

const slideOptions = {
    duration: 200,
};